import React, { useState } from "react";
import light from "../../assets/icons/light.webp";
import waterdrop from "../../assets/icons/waterdrop.webp";
import CustomInput from "../CustomInput";
import { Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import style from "./index.css";
import { createResourceRecord } from "../../services/resources";
import { useSelector } from "react-redux";
import { IS_LOCAL_ENV } from "../../App";
import { ToastContainer } from "react-toastify";
import Notification from "../ui-elements/Notification";

const typeProps = {
  Agua: {
    img: waterdrop,
    shortedUnit: "ml",
    unit: "Litros",
  },
  Luz: {
    img: light,
    shortedUnit: "lm",
    unit: "Lúmenes",
  },
};

const RegForm = ({ type }) => {
  const user = useSelector((state) => state.auth.user);
  const [creating, setCreating] = useState(false);
  const [quantity, setQuantity] = useState("");
  const [date, setDate] = useState("");
  const [unit, setUnit] = useState("");
  const changeUValue = (e) => {
    setUnit(e.target.value);
  };
  const changeQValue = (e) => {
    setQuantity(e.target.value);
  };
  const changeDValue = (e) => {
    const localDate = e.target.value;
    IS_LOCAL_ENV && console.log(localDate);
    setDate(localDate);
  };

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const sendData = async (props) => {
      try {
        setCreating(true);
        const response = await createResourceRecord(props);
        setCreating(false);
        Notification({
          title: "Operación completada",
          text: `Se registró el consumo de ${type}`,
          type: "Success",
        });
      } catch (err) {
        setCreating(false);
        Notification({
          title: "Error",
          text: `Algo salió mal`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };
    if (quantity != "" && date && unit != "") {
      const formatedDate = new Date(date);
      let props = {
        resource: type == "Agua" ? "water" : "light",
        quantity: quantity,
        dateAndTime: formatedDate.toISOString(),
        unit: unit,
        user: user.id,
      };
      sendData(props);
    } else {
      Notification({
        title: "Operación inválida",
        text: `Completa todos los campos`,
        type: "Error",
      });
    }
  };

  //form para registro de agua o de luz
  return (
    <div className="w-full max-w-[500px] rounded-10px h-fit border-[1px] bg-white rounded-xl shadow-md border-accent-green m-2 p-6 flex flex-col items-center">
      <div className="flex flex-row m-2 w-full">
        <div className="flex items-center justify-center">
          <img src={typeProps[type].img} className="h-[60px]" />
          {/* <div className={`absolute inset-0 bg-black opacity-30  z-20  `} /> */}
        </div>
        <h1 className="pt-4 text-2xl font-bold font-poppins text-dark-blue">
          {type}
        </h1>
      </div>
      <form className="w-full flex flex-col items-center">
        <CustomInput
          title={"Cantidad"}
          value={quantity}
          onChange={changeQValue}
          placeholder={`ej: 200 ${typeProps[type].shortedUnit}`}
          inputType={"number"}
          required={true}
        />
        <CustomInput
          title={"Unidad y medida"}
          value={unit}
          onChange={changeUValue}
          placeholder={typeProps[type].unit}
          inputType="text"
          required={true}
        />
        <CustomInput
          title={"Fecha y hora"}
          value={date}
          onChange={changeDValue}
          placeholder={`ej: 12/09/24 3:31`}
          inputType="datetime-local"
          required={true}
        />
        <button
          className={` w-fit bg-dark-green text-xl  rounded-full py-4 px-8 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins `}
          type="submit"
          onClick={handleSubmit}
          disabled={creating}
        >
          Registrar
        </button>
      </form>
      <span className="text-average-gray my-4 font-poppins font-bold ">
        <Link
          color="inherit"
          className="hover:cursor-pointer"
          onClick={() => navigate(`historial/${type.toLowerCase()}`)}
        >
          Ver historial
        </Link>
      </span>
    </div>
  );
};

export default RegForm;
